<template>
  <div class="content">
    <div class="md-layout">
      <div
        class="md-layout-item md-medium-size-50 md-xsmall-size-100 md-size-33"
      >
        <stats-card data-background-color="green">
          <template slot="header">
            <md-icon>thumb_up</md-icon>
          </template>

          <template slot="content">
            <p class="category">Recaudacion</p>
            <h3 class="title" v-if="recaudacion != null">${{ recaudacion }}</h3>
            <h3 class="title" v-else>$0.00</h3>
          </template>

          <template slot="footer">
            <div class="stats">
              <md-icon>access_time</md-icon>
              Hoy
            </div>
          </template>
        </stats-card>
      </div>
      <div
        class="md-layout-item md-medium-size-50 md-xsmall-size-100 md-size-33"
      >
        <stats-card data-background-color="orange">
          <template slot="header">
            <md-icon>assignment_turned_in</md-icon>
          </template>

          <template slot="content">
            <p class="category">Pedidos entregados hoy</p>
            <h3 class="title">
              {{ entregados }}
            </h3>
          </template>

          <template slot="footer">
            <div class="stats">
              <md-icon class="stats">access_time</md-icon>
              Hoy
            </div>
          </template>
        </stats-card>
      </div>
      <div
        class="md-layout-item md-medium-size-50 md-xsmall-size-100 md-size-33"
      >
        <stats-card data-background-color="blue">
          <template slot="header">
            <md-icon>new_releases</md-icon>
          </template>

          <template slot="content">
            <p class="category">Nuevos Pedios</p>
            <h3 class="title">{{ nuevospedidos }}</h3>
          </template>

          <template slot="footer">
            <div class="stats">
              <md-icon>access_time</md-icon>
              Hoy
            </div>
          </template>
        </stats-card>
      </div>
      <span style ="margin-right: 16px"><md-icon style="color: pink">circle</md-icon> <b>Postergados</b></span>
      <span style ="margin-right: 16px"><md-icon style="color: yellow">circle</md-icon> <b>Pendientes</b></span>
      <span style ="margin-right: 16px"><md-icon style="color: green">circle</md-icon> <b>Entregados</b></span>
        <Calendar></Calendar>
    </div>
  </div>
</template>

<script>
import {
  StatsCard,
  NavTabsCard,
  NavTabsTable,
  OrderedTable,
} from "@/components";


import Calendar from "./../components/Calendar/Calendar";

import axios from "axios";
import Global from "../Global";

export default {
  components: {
    StatsCard,
    Calendar
  },
  data() {
    return {
      url: Global.url,
      recaudacion: null,
      entregados: null,
      nuevospedidos: null
    };
  },
  mounted() {
    axios
      .get(this.url + "pedido/recaudacion/send", {
        headers: { ApiToken: localStorage.usertoken }
      })
      .then(Response => {
        if (Response.status == 200) {
          this.recaudacion = Response.data.ingreso;
        }
      })
      .catch(error => {
        alert(error);
      });

    axios
      .get(this.url + "pedido/entregados/send", {
        headers: { ApiToken: localStorage.usertoken }
      })
      .then(Response => {
        if (Response.status == 200) {
          this.entregados = Response.data.pedidos;
        }
      })
      .catch(error => {
        alert(error);
      });
    axios
      .get(this.url + "pedido/nuevos/send", {
        headers: { ApiToken: localStorage.usertoken }
      })
      .then(Response => {
        if (Response.status == 200) {
          this.nuevospedidos = Response.data.pedidos;
        }
      })
      .catch(error => {
        alert(error);
      });
  }
};
</script>
